<template>
  <div :class="{snote: !integrated}">
    <div class="note"></div>
  </div>
</template>

<script>
require("summernote/dist/summernote.css");
import $ from "jquery";
import sn from "summernote";

export default {
  name: "RichText",
  props: {
    initial: true,
    options: true,
    text: true,
    initSettings: true,
    refresh: true,
	integrated: { type: Boolean, default: false },
  },
  data() {

    var defaults = {
      toolbar: [
        ["style", ["bold", "italic", "underline", "strikethrough", "clear"]],
        ["fontsize", ["fontsize"]],
        ["para", ["ul", "ol", "paragraph"]],
        ["meta", ["undo", "redo"]],
        ["color", ["color"]],
        ["insert", ["picture", "link","table"]]
      ],
      height: 300,
      placeholder: "Write message here..."
    };
    return {
      mut_text: _.cloneDeep(this.text),
      mut_opts: _.extend(defaults, this.options)
    };
  },
  mounted() {
    this.initialize(this.initial);
  },

  watch: {
    initial() {
      this.loadInitial();
    },
    refresh() {
      this.loadInitial();
    }
  },

  destroyed() {
    this.destroy();
  },

  methods: {
    loadInitial() {
      var el = $(this.$el).find(".note");
      el.summernote("code", this.initial);
    },

    changed(we, contents, $editable) {
      this.$emit("update:text", contents);
    },

    destroy() {
      $(this.$el)
        .find("note")
        .summernote("destroy");
    },

    initialize(innerHTML) {
      var el = $(this.$el).find(".note");
      el.summernote(this.mut_opts);
      el.on("summernote.change", this.changed);
      if (this.initial) {
        el.summernote("code", this.initial);
      } else if (this.initSettings) {
        _.each(this.initSettings, (value, setting) => {
          el.summernote(setting, value);
        });
      }
      // this.defaults.toolbar.append(["insert", ["picture", "link"]])
    }
  }
};
</script>

<style scoped>
.snote {
  background-color: white;
  margin-bottom: 20px;
}
.dropdown-menu {
  color: initial;
  font-size: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/RichText.vue